const totalMainShowViewList = [
  {
    label: 'admin.hrDashboard.containerTitle.jobs',
    key: 'jobs'
  },
  {
    label: 'admin.hrDashboard.containerTitle.channels',
    key: 'channels'
  },
  {
    label: 'admin.hrDashboard.containerTitle.applications',
    key: 'applications'
  }
]
const totalRightShowViewList = [
  {
    label: 'admin.hrDashboard.containerTitle.notification',
    key: 'newAlerts'
  }
]

export default {
  data () {
    return {
    }
  },
  computed: {
    hasInterviewPermission () {
      return this.hasAnyPermission(['PERM_HR_INTERVIEW_SCHEDULING', 'PREMIUM_INTERVIEW_SCHEDULING'])
    },
    hasTalentPoolPermission () {
      return this.hasAnyPermission(['PERM_TALENTPOOL_GET', 'PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT'])
    },
    hasJobCreatePermission () {
      return this.hasAnyPermission('PERM_JOB_CREATE')
    },
    hasJobViewPermission () {
      return this.hasAnyPermission('PERM_JOB_GET')
    },
    hasRecruiterKpiPermission () {
      return this.hasAnyPermission(['PERM_VIEW_CHART_REPORT', 'PREMIUM_EXPORT_DATA'])
    },
    hasLeadsPermission () {
      return this.hasAnyPermission('PREMIUM_SOFT_USER')
    },
    hasHrReportPermission () {
      return this.hasAnyPermission(['PERM_VIEW_HR_REPORT', 'PREMIUM_HR_REPORT'])
    },
    totalMainList () {
      const result = [...totalMainShowViewList]
      if (this.hasTalentPoolPermission) {
        result.push({
          label: 'admin.hrDashboard.containerTitle.talentPool',
          key: 'talentPool'
        })
      }
      if (this.hasRecruiterKpiPermission) {
        result.push({
          label: 'admin.hrDashboard.containerTitle.recruiterKpi',
          key: 'recruiterKpi'
        })
      }
      return result
    },
    totalRightList () {
      const result = []
      if (this.hasInterviewPermission) {
        result.push({
          label: 'admin.hrDashboard.containerTitle.interviews',
          key: 'interviews'
        })
      }
      result.push(...totalRightShowViewList)
      return result
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
  },
  watch: {
  }
}
